module.exports = __webpack_public_path__ + "media/images/crowd-enjoyment-92b99a635934c5521a52ad8ce29b4da9.png";